import { Fragment, useRef, useState, useEffect} from 'react'
import { Dialog, Transition } from '@headlessui/react'
import app from "../../api/firebaseConf";
import { collection, getFirestore, addDoc, getDocs, updateDoc,doc, getDoc } from "firebase/firestore";
import { toast } from "react-toastify";


export default function FormRooms(props) {

      const initState = {
        nombre: "",
        parametro: "",
        topico: "",
        };

      const [values, setValues] = useState(initState);
      const db = getFirestore(app)
    
      const addItems = async(object) =>{
        await addDoc(collection(db,'habitaciones'), object)
        toast('Nueva habitacion agregada', {
          type: 'success',
        })
      } 
      
      const updDoc = async (id) => {
        await updateDoc(doc(db, "habitaciones", id), values);
        toast('Campo editado correctamente', {
          type: 'success',
        })
      }
    
      const cssinput = "appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white";
      const csslabel = "block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2";
    
      const handleInputChange = e => {
        const {name, value} = e.target
        //console.log(e.target.value)
        setValues({...values, [name]: value})
      }

      const handleSubmit = (e) => {
        e.preventDefault();
        
        if (props.id === ""){
          addItems(values)}
        else{
          updDoc(props.id)
        }
      };

      

      useEffect(()=>{
        const getDocbyId = async (id) =>{
          const datos = await getDoc(doc(db,'habitaciones',id));
          setValues({...datos.data()})
          console.log(datos.data())
        }

        if(props.id === ""){
          //console.log("vacio")
          setValues({...initState})
        }else {
          getDocbyId(props.id)
        }
      },[props.id])

      const cancelButtonRef = useRef(null)

  return (
    <Transition.Root show={props.open} as={Fragment}>
      <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={props.close}>
        {//Fondo opaco
          <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>}
        
        <div className="fixed z-10 inset-0 overflow-y-auto">
          <div className="flex items-center sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full">
                <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                <div className="grid justify-items-end">
                  <button 
                    type="button" 
                    className="inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 " 
                    onClick={props.close} 
                    ref={cancelButtonRef}> X </button>
                  </div>

                  {/*Formulario para las habitaciones*/}
                    <form className="w-full max-w-lg" onSubmit={handleSubmit}>
                        <div className="grid grid-cols-1 gap-x-4">
                            <div>
                            <label className={csslabel}>Nombre</label>
                            <input
                                className={cssinput}
                                type="text"
                                name = "nombre"
                                placeholder="Nombre de la habitacion"
                                onChange={handleInputChange}
                                value={values.nombre}
                            />
                            </div>
                            {/* <div>
                            <label className={csslabel}>Parametro 1</label>
                            <input
                                className={cssinput}
                                type="text"
                                name = "parametro"
                                placeholder="Ingrese el algo"
                                onChange={handleInputChange}
                                value={values.parametro}
                            />
                            </div> */}
                        </div>
                        <div className="grid grid-cols-1">
                            <label className={csslabel}>Topico</label>
                            <input 
                                className={cssinput} 
                                type="text" 
                                name = "topico"
                                placeholder="Ingrese el Topico" 
                                onChange={handleInputChange}
                                value={values.topico} />
                        </div>

                        <div className=" px-4 py-3 sm:px-1 sm:flex sm:flex-row-reverse">
                            <button className="w-full inline-flex justify-center rounded-md border border-transparent 
                            shadow-sm px-4 py-2 bg-red-600 text-base font-medium 
                            text-white hover:bg-red-700 focus:outline-none focus:ring-2 
                            focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm" onClick={props.close}>
                            {props.id === "" ? "Guardar": "Editar"}
                            </button>
                        </div>
                    </form>
                </div>         
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}
